import React from 'react'

import { FormDensity } from './ui2-form-props'

export interface IUI2FormContext {
  formDensity?: FormDensity
  /** If true, force every child field into read-only. Overrides child prop. */
  isReadOnly?: boolean
  /** If true, force every child field into disabled. Overrides child prop. */
  isDisabled?: boolean
  /** Form-level default for `isRequired`. Overrideable by child prop. */
  isRequired?: boolean
  /** Form-level default for `isOptional`. Overrideable by child prop. */
  isOptional?: boolean
  /** Form-level default for `isCollapsed`. Overrideable by child prop. */
  isCollapsed?: boolean
  /** Form-level default for `isCollapsable`. Overrideable by child prop. */
  isCollapsable?: boolean
  /** Form-level default for `isHorizontalLayout`. Overrideable by child prop. Only applicable for desktop web. */
  isHorizontalLayout?: boolean
  /** Form-level default for `enablePrefilledMode`. Overrideable by child prop. */
  enablePrefilledMode?: boolean
  /**
   * When explicitly `null`, descendant field labels suppress their `inlineHelpText`.
   * Used by stacked-mode completed sections to silence help text in read-only view.
   */
  inlineHelpText?: string | null
}

export const UI2FormContext = React.createContext<IUI2FormContext>({})
